import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, VendorAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/providers` (Vendors) — gates the whole subtree (listing +
 * vendor detail) behind `vendors:listing:read` via a single gated Outlet. (ENT-89 T15.)
 */
export const Route = createFileRoute('/providers')({
  component: withPermission(Outlet, {
    key: VendorAclKeys.listingRead,
    route: AclRoute.VENDOR,
    resourceLabel: 'Vendors',
  }),
});
